/**
 * patchUsername.js
 * Written by: Brian Kim
 */
import cookie from 'react-cookies';
import alertActions from 'store/alert/actions';
import request from '../../../request/actions';
import { loadToken } from '../loadToken';
import { hosts, formatAxiosError } from '../../../../utils';
import event from '../../../../utils/event';


export const PATCH_USERNAME_START = `PATCH_USERNAME_START`;
export const PATCH_USERNAME_SUCCESS = `PATCH_USERNAME_SUCCESS`;
export const PATCH_USERNAME_FAILURE = `PATCH_USERNAME_FAILURE`;

export const patchUsernameStart = () => ({
  type: PATCH_USERNAME_START,
});

export const patchUsernameSuccess = (user, id) => ({
  type: PATCH_USERNAME_SUCCESS,
  user,
  id,
});

export const patchUsernameFailure = (error) => ({
  type: PATCH_USERNAME_FAILURE,
  error,
});

/**
 * Description of the patchUsername action
 */
export const patchUsername = (data) => {
  return async (dispatch) => {
    dispatch(patchUsernameStart());
    try {
      const response = await dispatch(request(`/users/me/`, `PATCH`, { ...data }));
      const curUsername = response.data.username;
      event(`edit-username`, [`click`, `edit-username`, curUsername]);
      cookie.save(`jwtToken`, response.data.jwt, {
        path: `/`,
        expires: new Date(253402300000000),
        domain: hosts.cookieDomain,
      });
      dispatch(patchUsernameSuccess(response.data, response.data.id));
      dispatch(loadToken(response.data.jwt));
    } catch (e) {
      if (e instanceof Error) {
        event(`edit-username-failure`, [`error`, `edit-username-failure`, `${e.message}`]);
        throw e;
      }
      event(`edit-username-failure`, [`error`, `edit-username-failure`, `${e.response.status}`]);
      dispatch(patchUsernameFailure(e.response));
      if (e.response.status === 409) {
        dispatch(alertActions.createAlert({
          message: e.response.data.detail,
          type: `danger`,
        }));
      } else {
        dispatch(alertActions.createAlert({
          message: `An unknown error has occured`,
          type: `danger`,
        }));
        const errMsg = formatAxiosError(`patchUsername`);
        throw new Error(errMsg);
      }
    }
  };
};
